import React, { useState } from "react";
import "../../popups.css";

const AddMemberPopup = ({ onClose, onNext }) => {
  const [openSection, setOpenSection] = useState("grandfather"); // default open
  const [grandfatherData, setGrandfatherData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    suffix: "",
    maidenName: "",
    nickName: "",
    gender: "",
    dob: "",
    aliveStatus: "",
    dod: "",
    ageOfDeath: "",
    relation: "Self",
  });

  const [grandmotherData, setGrandmotherData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    suffix: "",
    maidenName: "",
    nickName: "",
    gender: "",
    dob: "",
    aliveStatus: "",
    dod: "",
    ageOfDeath: "",
    relation: "Grandmother - Spouse",
  });

  const handleGrandfatherChange = (e) => {
    const { name, value } = e.target;
    setGrandfatherData((prev) => ({ ...prev, [name]: value }));
  };

  const handleGrandmotherChange = (e) => {
    const { name, value } = e.target;
    setGrandmotherData((prev) => ({ ...prev, [name]: value }));
  };

  const toggleSection = (section) => {
    setOpenSection((prev) => (prev === section ? "" : section));
  };

  return (
    <div className="popup-overlay addmember-overlay">
      <div className="popup-card addmember-card">
        {/* ===== Header ===== */}
        <div className="popup-header addmember-header">
          <div className="header-left">
            <div className="">
              <img src="/assets/images/add-member.svg" alt="user" />
            </div>
            <div>
              <h2>Add Member</h2>
              <p>
                Enter family member details for printing and genealogy hierarchy.
                Layout has been automatically selected based on your prior choice.
              </p>
            </div>
          </div>
          <button className="close-btn" onClick={onClose}>
            &times;
          </button>
        </div>

        {/* ===== Scrollable Content ===== */}
        <div className="popup-body addmember-body">
          <div className="addmember-body-scroll">
          {/* ===== Grandfather Section ===== */}
          <div className="section addmember-section">
            <div
              className="section-header addmember-section-header"
              onClick={() => toggleSection("grandfather")}
            >
              <h3>Primary Grandfather Info</h3>
              <span
                className={`dropdown-icon ${
                  openSection === "grandfather" ? "rotated" : ""
                }`}
              >
                ▼
              </span>
            </div>

            {openSection === "grandfather" && (
              <>
                <div className="image-row addmember-image-row">
                  <div className="member-photo">
                    <img src="../assets/images/d-user.jpg" alt="Member" />
                  </div>
                  <div className="member-photo">
                    <img src="../assets/images/d-user.jpg" alt="Member" />
                  </div>
                  <div className="add-photo">
                    <span>+</span>
                  </div>
                </div>

                <div className="form-grid addmember-form-grid">
                  {[
                    "firstName",
                    "middleName",
                    "lastName",
                    "suffix",
                    "maidenName",
                    "nickName",
                  ].map((field) => (
                    <div className="form-group addmember-form-group" key={field}>
                      <label>{field.replace(/([A-Z])/g, " $1")}</label>
                      <input
                        type="text"
                        name={field}
                        value={grandfatherData[field]}
                        onChange={handleGrandfatherChange}
                      />
                    </div>
                  ))}

                  <div className="form-group addmember-form-group">
                    <label>Gender</label>
                    <select
                      name="gender"
                      value={grandfatherData.gender}
                      onChange={handleGrandfatherChange}
                    >
                      <option value="">Select</option>
                      <option>Male</option>
                      <option>Female</option>
                    </select>
                  </div>

                  <div className="form-group addmember-form-group">
                    <label>Date of Birth</label>
                    <input
                      type="date"
                      name="dob"
                      value={grandfatherData.dob}
                      onChange={handleGrandfatherChange}
                    />
                  </div>

                  <div className="form-group addmember-form-group">
                    <label>Living / Deceased</label>
                    <select
                      name="aliveStatus"
                      value={grandfatherData.aliveStatus}
                      onChange={handleGrandfatherChange}
                    >
                      <option value="">Select</option>
                      <option>Living</option>
                      <option>Deceased</option>
                    </select>
                  </div>

                  <div className="form-group addmember-form-group">
                    <label>Date of Death</label>
                    <input
                      type="date"
                      name="dod"
                      value={grandfatherData.dod}
                      onChange={handleGrandfatherChange}
                    />
                  </div>

                  <div className="form-group addmember-form-group">
                    <label>Age of Death</label>
                    <input
                      type="text"
                      name="ageOfDeath"
                      value={grandfatherData.ageOfDeath}
                      onChange={handleGrandfatherChange}
                    />
                  </div>

                  <div className="form-group addmember-form-group">
                    <label>Relation</label>
                    <input
                      type="text"
                      name="relation"
                      value={grandfatherData.relation}
                      readOnly
                    />
                  </div>
                </div>
              </>
            )}
          </div>

          {/* ===== Grandmother Section ===== */}
          <div className="section spouse-section addmember-section">
            <div
              className="section-header addmember-section-header"
              onClick={() => toggleSection("grandmother")}
            >
              <h3>Spouse (Grandmother) Info</h3>
              <span
                className={`dropdown-icon ${
                  openSection === "grandmother" ? "rotated" : ""
                }`}
              >
                ▼
              </span>
            </div>

            {openSection === "grandmother" && (
              <>
                <div className="image-row addmember-image-row">
                  <div className="member-photo">
                    <img src="../assets/images/d-user.jpg" alt="Member" />
                  </div>
                  <div className="add-photo">
                    <span>+</span>
                  </div>
                </div>

                <div className="form-grid addmember-form-grid">
                  {[
                    "firstName",
                    "middleName",
                    "lastName",
                    "suffix",
                    "maidenName",
                    "nickName",
                  ].map((field) => (
                    <div className="form-group addmember-form-group" key={field}>
                      <label>{field.replace(/([A-Z])/g, " $1")}</label>
                      <input
                        type="text"
                        name={field}
                        value={grandmotherData[field]}
                        onChange={handleGrandmotherChange}
                      />
                    </div>
                  ))}

                  <div className="form-group addmember-form-group">
                    <label>Gender</label>
                    <select
                      name="gender"
                      value={grandmotherData.gender}
                      onChange={handleGrandmotherChange}
                    >
                      <option value="">Select</option>
                      <option>Female</option>
                      <option>Male</option>
                    </select>
                  </div>

                  <div className="form-group addmember-form-group">
                    <label>Date of Birth</label>
                    <input
                      type="date"
                      name="dob"
                      value={grandmotherData.dob}
                      onChange={handleGrandmotherChange}
                    />
                  </div>

                  <div className="form-group addmember-form-group">
                    <label>Living / Deceased</label>
                    <select
                      name="aliveStatus"
                      value={grandmotherData.aliveStatus}
                      onChange={handleGrandmotherChange}
                    >
                      <option value="">Select</option>
                      <option>Living</option>
                      <option>Deceased</option>
                    </select>
                  </div>

                  <div className="form-group addmember-form-group">
                    <label>Date of Death</label>
                    <input
                      type="date"
                      name="dod"
                      value={grandmotherData.dod}
                      onChange={handleGrandmotherChange}
                    />
                  </div>

                  <div className="form-group addmember-form-group">
                    <label>Age of Death</label>
                    <input
                      type="text"
                      name="ageOfDeath"
                      value={grandmotherData.ageOfDeath}
                      onChange={handleGrandmotherChange}
                    />
                  </div>

                  <div className="form-group addmember-form-group">
                    <label>Relation</label>
                    <input
                      type="text"
                      name="relation"
                      value={grandmotherData.relation}
                      readOnly
                    />
                  </div>
                </div>
              </>
            )}
          </div>
          </div>
        </div>

        {/* ===== Footer Buttons ===== */}
        <div className="popup-actions addmember-actions">
          <button className="btn-outline" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-primary" onClick={onNext}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddMemberPopup;
